import { PortfolioModel } from "@modelve/api/models/portfolioModels";
import { useEffect } from "react";
import { useParams } from "react-router";
import { create } from "zustand";
import { getApiClient } from "./client";
import { useApiErrorContext } from "./errorContext";
import { portfolioApi } from "./resources/adminResources";

interface ApiStoreState {
  portfolioId?: string;
  tenantId?: string;

  setRoute: (portfolioId?: string, tenantId?: string) => Promise<void>;
}

export const useApiStore = create<ApiStoreState>()((set) => ({
  setRoute: async (portfolioId, tenantId) => {
    if (portfolioId && !tenantId) {
      set({ portfolioId: portfolioId, tenantId: undefined });
      const data = await getApiClient().get<PortfolioModel>(
        portfolioApi.detail(portfolioId).route,
      );
      set({ tenantId: data.data.tenantId });
    } else {
      set({ portfolioId: portfolioId, tenantId: tenantId });
    }
  },
}));

function useInitializeStore() {
  const { tenantId, portfolioId } = useParams();
  const { reportError } = useApiErrorContext();
  useEffect(() => {
    const updateRoute = async () => {
      try {
        await useApiStore.getState().setRoute(portfolioId, tenantId);
      } catch (error) {
        reportError(error);
      }
    };

    void updateRoute();
  }, [portfolioId, tenantId, reportError]);
}

export function useApiProvider() {
  useInitializeStore();
}
